import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/linode': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M437.4 226.3c0.6 2-8.8 66.3-9.7 72.8 0 0.9-0.5 1.7-1.1 2l-54.6 43.7c-1.1 0.9-2.6 0.9-3.7 0l-20.3-14-2.3 33.4c0 0.9-0.2 1.7-1.1 2.3l-66.9 53.4c-1.1 0.9-2.9 0.9-4 0l-28-23.7 2 46c0 0.9-0.2 1.7-1.1 2.3l-83.7 66.9c-0.6 0.3-1.1 0.6-1.7 0.6-0.9-0.3-1.7-0.3-2.3-0.9l-65.1-69.1c-1.5-1.4-15.5-72-16.9-79.1-0.3-1.1 0.5-2.5 1.4-3.1l17.4-10.6c-3.4-3.2-26.5-23.4-27.1-26.3l-20.6-100.3c-0.3-1.1 0.3-2.5 1.7-3.4l26.9-12.9c-4.6-3.5-37.7-27.5-38.6-30.9l-27.4-133.1c-0.3-1.7 0.6-3.1 2-3.7l123.7-38.6c0.6 0 1.4 0 2.3 0.3l90.6 43.7c0.8 0.6 1.7 1.7 1.7 2.6l5.7 132.3c0 1.2-0.6 2.3-1.7 2.9l-33.7 17.4 36 24.3c0.8 0.3 1.4 1.4 1.4 2.3l1.4 35.1 34.6-21.2c0.8-0.6 2.2-0.6 3.1 0l24 16 0.9-31.4c0-0.9 0.5-2 1.4-2.6l58.9-36c1.1-0.6 2.2-0.6 3.1 0l70 38.6c0.5 0.6 1.1 1.1 1.4 2zM232.6 231.1l-100.6 57.2 14 96.6 90.6-61.2zM224.9 51.1l-120.9 46.6 19.7 134.8 106.6-55.4zM44 173.1l73.1 57.2-19.4-132.9-79.7-49.4zM74.6 320.9l64.8 60.8-13.7-93.4-70-58.3zM98.9 438.6l57.7 61.2-9.7-67.4-61.7-60.9zM163.4 503.1l78.2-62.3-3.1-70-85.7 61.4zM245.4 388l27.1 22.9-0.6-68.3-29.4-22.6c0 2.3 1.2 6.3-1.1 8l-22.3 14.9 24.3 20c2.9 2.2 2 21.7 2 25.1zM339.7 362.6l4.2-66.9-65.7 46.9 0.6 68.6zM367.4 336.9l5.8-66.6-64.6-40.6-0.6 30 41.2 27.2c0.8 0.6 1.4 1.7 1.1 2.6l-2 34zM422 297.1l8.5-63.4-51.1 36.6-5.7 65.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linode.js
// module id = 920
// module chunks = 0